import React, { useState } from 'react'
import Page from 'src/components/Page'
import styles from './styles' // Importing styles

// material
import { styled } from '@material-ui/core/styles'
import { Box, Typography, withStyles } from '@material-ui/core'
import CustomizedSwitch from 'src/components/customized-switch'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(() => ({
  width: '100%', // Full width on mobile
  maxWidth: 1200,
  marginTop: 40,
  height: 'auto',
}))

// ----------------------------------------------------------------------

const Header = props => {
  const { setData, type, classes } = props
  const [timeInterval, setTimeInterval] = useState(true)

  const handleChange = () => {
    setTimeInterval(!timeInterval)
    setData(!timeInterval)
  }

  return (
    <RootStyle title="Header">
      <Typography className={classes.header}>Pricing</Typography>
      <Typography className={classes.title}>
        Break the limits with paid plans.
      </Typography>
      <Typography className={classes.subtitle}>
        Start your subscription and get the most out of Mini Course Generator.
        Join 10,000+ course creators <br />
        to simplify eLearning authoring and course delivery for your educational
        programs.
      </Typography>
      <Box className={classes.box}>
        <Typography className={classes.switchLabel}>Monthly</Typography>
        <CustomizedSwitch checked={timeInterval} onChange={handleChange} />
        <Typography className={classes.switchLabel}>
          Annual (Save 50%)
        </Typography>
      </Box>
      <Box className={classes.box}>
        <Box className={classes.boxPlan}>
          <Typography className={classes.currently}>Currently on</Typography>
          <Typography className={classes.plan}>{type} Plan</Typography>
        </Box>
      </Box>
    </RootStyle>
  )
}

export default withStyles(styles)(Header)
